const sectionID = `shopify-section-${document.currentScript.getAttribute('section')}`
const section = document.querySelector(`#${sectionID}`)
const popup = section.querySelector('[data-popup]')
const closeButtons = section.querySelectorAll('[data-close]')
const demoMode = document.currentScript.getAttribute('data-demo-mode') === 'true'

const storeData = JSON.parse(section.querySelector('[data-stores]').innerHTML)
const current_market = storeData.current_market
const markets = storeData.markets || []
const external_stores = storeData.external_stores || []

const url = new URL(window.location.href)
const botPattern =
  '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)'
const botRegex = new RegExp(botPattern, 'i')

const getVisitorCountry = async () => {
  return await fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
    .then((r) => r.json())
    .then((data) => {
      return {
        ...data.detected_values.country,
      }
    })
}

const getLocationSuggestion = async () => {
  const visitor = await getVisitorCountry()
  const visitorCountryCode = visitor.handle

  // Check if visitor is already on their market
  if (current_market.iso_code === visitorCountryCode) {
    return null // Already on correct market, no suggestion needed
  }

  // Find matching Shopify market for visitor
  const matchingMarket = markets.find((market) => market.iso_code === visitorCountryCode)

  if (matchingMarket) {
    return {
      type: 'market',
      location: matchingMarket,
    }
  }

  // No matching market - check external stores
  const matchingExternalStore = external_stores.find(
    (store) => store.display_country_code.toUpperCase() === visitorCountryCode.toUpperCase()
  )

  if (matchingExternalStore) {
    return {
      type: 'external',
      location: matchingExternalStore,
    }
  }

  // No matching market or external store found
  return null
}

const init = async () => {
  const result = await getLocationSuggestion()

  if (!result) {
    return
  }

  const { type, location } = result
  const locationElement = section.querySelector('[data-geo-location]')

  let locationStoreButton

  if (type === 'market') {
    // Shopify market suggestion - use localization form
    const countryInput = section.querySelector('[data-country-input]')
    countryInput.value = location.iso_code

    locationStoreButton = document.createElement('button')
    locationStoreButton.type = 'submit'
    locationStoreButton.classList = 'button button--primary button--xl'
    locationStoreButton.innerHTML = `
      <img
        src="//cdn.shopify.com/static/images/flags/${location.iso_code.toLowerCase()}.svg?width=32"
        alt="${location.name}"
        srcset="//cdn.shopify.com/static/images/flags/${location.iso_code.toLowerCase()}.svg?width=32 32w"
        width="32"
        height="24"
      >
      <p>Go to ${location.name}</p>
    `
  } else if (type === 'external') {
    // External store suggestion - direct link
    locationStoreButton = document.createElement('a')
    locationStoreButton.href = location.url
    locationStoreButton.classList = 'button button--primary button--xl'

    // Support globe icon for INT stores
    const countryCode = location.display_country_code.toUpperCase()
    const flagHtml = countryCode === 'INT'
      ? `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
        </svg>`
      : `<img
          src="//cdn.shopify.com/static/images/flags/${location.display_country_code.toLowerCase()}.svg?width=32"
          alt="${location.name}"
          srcset="//cdn.shopify.com/static/images/flags/${location.display_country_code.toLowerCase()}.svg?width=32 32w"
          width="32"
          height="24"
        >`

    locationStoreButton.innerHTML = `
      ${flagHtml}
      <p>Go to ${location.name}</p>
    `
  }

  locationElement.replaceWith(locationStoreButton)

  popup.hidden = false

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      popup.hidden = true
      if (!demoMode) {
        localStorage.setItem('dtails:geo-location', 'true')
      }
    })
  })
}

if (!botRegex.test(navigator.userAgent)) {
  if (demoMode) {
    // Demo mode: always show popup for testing
    init()
  } else {
    // Normal mode: show only once per session
    const hasShownPopup = localStorage.getItem('dtails:geo-location')
    if (!hasShownPopup) init()
  }
}

